module.exports = __webpack_public_path__ + "static/media/Chart.4029152c.svg";